import React, { useState } from 'react'
import Button from '@material-ui/core/Button'
import Popover from '@material-ui/core/Popover'
import EventIcon from 'components/material-symbol/icons/Event'
import { DateCalendar, LocalizationProvider } from '@mui/x-date-pickers'
import { ThemeProvider } from '@mui/material/styles'
import CustomLuxonAdapter from 'lib/CustomLuxonAdapter'
import useCalendarStyles from 'pages/pga-coach/bookings/schedule/calendar/calendar-styles'
import { calendarDatePickerTheme } from 'pages/pga-coach/bookings/schedule/calendar/calendar-date-picker-theme'
import {
  calendarDateCalendarSlots,
  calendarDateCalendarSlotProps,
} from 'pages/pga-coach/bookings/schedule/calendar/calendar-date-calendar-slots'
import { formatWeekLabel } from './utils'

const WeekNavigator = ({ weekRange, referenceDate, onJumpToDate }) => {
  const calendarClasses = useCalendarStyles()
  const [pickerAnchor, setPickerAnchor] = useState(null)

  const handleChange = date => {
    if (!date?.isValid || !onJumpToDate) return
    onJumpToDate(date)
    setPickerAnchor(null)
  }

  const pickerOpen = Boolean(pickerAnchor)
  const calendarValue =
    referenceDate?.isValid != null && referenceDate.isValid
      ? referenceDate
      : weekRange.start

  return (
    <>
      <Button
        variant="outlined"
        className={calendarClasses.datePickerButton}
        startIcon={<EventIcon fontSize="small" />}
        onClick={event => setPickerAnchor(event.currentTarget)}
        aria-label="Jump to week"
        aria-haspopup="dialog"
        aria-expanded={pickerOpen}
      >
        {formatWeekLabel(weekRange)}
      </Button>
      <Popover
        open={pickerOpen}
        anchorEl={pickerAnchor}
        onClose={() => setPickerAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        classes={{ paper: calendarClasses.datePickerPopover }}
        marginThreshold={8}
      >
        <ThemeProvider theme={calendarDatePickerTheme}>
          <LocalizationProvider dateAdapter={CustomLuxonAdapter} locale="en-us">
            <DateCalendar
              value={calendarValue}
              onChange={handleChange}
              dayOfWeekFormatter={day => `${day}`}
              className={calendarClasses.dateCalendar}
              slots={calendarDateCalendarSlots}
              slotProps={calendarDateCalendarSlotProps}
            />
          </LocalizationProvider>
        </ThemeProvider>
      </Popover>
    </>
  )
}

export default WeekNavigator
